
import BackgroundGray from "@/components/helpers/BackgroundGray.vue";
import Header from "@/components/partials/Header.vue";
import Title from "@/components/style/Title.vue";
import PhotoCredits from "@/components/partials/PhotoCredits.vue";
import Breadcrumbs from "@/components/partials/Breadcrumbs.vue";
import Money from "@/components/helpers/Money.vue";
import AirportsMap from "@/components/partials/seo/AirportsMap.vue";
import ListAirlines from "@/components/partials/ListAirlines.vue";
import ListAirports from "@/components/partials/ListAirports.vue";
import Footer from "@/components/partials/Footer.vue";
import ListSearches from "@/components/partials/ListSearches.vue";
import ListFlightMonths from "@/components/partials/ListFlightMonths.vue";

export default {
  components: {
    ListFlightMonths,
    ListSearches,
    Footer,
    ListAirports,
    ListAirlines,
    AirportsMap,
    Money,
    Breadcrumbs,
    PhotoCredits,
    Title,
    Header,
    BackgroundGray
  },
  data() {
    return {
      breadcrumbs: [],
      searches: [],
      aircompaniesCalendar: [],
      airportsCalendar: [],
      months: [],
      page: {
        image: ''
      },
    }
  },
  nuxtI18n: {
    paths: {
      'en': '/flights-to-:destination',
      'it': '/voli-per-:destination',
      'ro': '/zboruri-spre-:destination',
      'ru': '/reysy-v-:destination',
      'pl': '/loty-do-:destination',
      'de': '/fluge-nach-:destination',
      'es': '/vuelos-a-:destination',
      'pt': '/voos-para-:destination',
      'hu': '/jaratok-a-:destination',
      'fi': '/lennot-:destination',
      'sv': '/flygningar-till-:destination',
      'da': '/flyvninger-til-:destination',
      'fr': '/vols-vers-:destination'
    }
  },
  async fetch() {
    const page = await this.$api.contents.query({
      multiple: false,
      type: 'flights-to',
      slug: this.$route.params.destination
    }).then((res) => {
      return res.data.content;
    })
    this.page = page;

    const searches = await this.$api.flightCalendar.query({
      destination: this.page.custom_data.airport.airport_code,
      limit: 10
    }).then((res) => {
      return res.data;
    })
    this.searches = searches.calendars;
    this.aircompaniesCalendar = searches.aircompanies;
    this.airportsCalendar = searches.airports;

    const months = await this.$api.flightCalendar.months({
      destination: this.page.custom_data.airport.airport_code,
      market_related: true,
    }).then((res) => {
      return res.data.months;
    })
    this.months = months;

    this.breadcrumbs.push({
      text: this.$t('home.Home'),
      to: {
        name: 'index'
      }
    });

    this.breadcrumbs.push({
      text: this.$t('seo-flights-to.Title', {to: this.page.custom_data.country}),
      to: {
        name: 'flights-to-destination',
        params: {
          destination: this.page.custom_data.country_slug
        }
      }
    });

    if (this.page.metadata.type_location !== 'country') {
      this.breadcrumbs.push({
        text: this.$t('seo-flights-to.Title', {to: this.page.custom_data.city_name})
      });
      this.$store.commit('seo/setCanonical', this.localeRoute({
        name: 'flights-to-destination',
        params: {
          destination: this.page.custom_data.city_name
        }
      }).fullPath);
      this.$store.commit('searchFlight/setDestination', this.page.custom_data.airport);
    } else {
      this.$store.commit('seo/setCanonical', this.localeRoute({
        name: 'flights-to-destination',
        params: {
          destination: this.page.custom_data.country_slug
        }
      }).fullPath);
      this.$store.commit('searchFlight/setDestination', this.page.custom_data.airport);
    }

    this.$store.commit('seo/setTitle', this.page.seo.title);
    this.$store.commit('seo/setDescription', this.page.seo.description);
    this.$store.commit('seo/setKeywords', this.page.seo.keywords);
    this.$store.commit('seo/setImage', this.page.image + '?format=jpg');
  }
}
